import { IncidentModel } from './incident.model';
export class CommonModel extends IncidentModel {

}
